export const categories = [
  { id: "ghee-and-oil", name: "Ghee and Oil", icon: "🧈" },
  { id: "beverages", name: "Beverages", icon: "🥤" },
  { id: "malt-and-health-mix", name: "Malt and Health Mix", icon: "🥣" },
  { id: "palm-products", name: "Palm Products", icon: "🌴" },
  { id: "rice-millets", name: "Rice Millets", icon: "🌾" },
  { id: "snacks", name: "Snacks", icon: "🍿" },
  { id: "tiffin", name: "Tiffin", icon: "🍽️" },
];

export const products = [
  // Beverages
  {
    id: 1,
    name: "Amla Immunity Booster",
    category: "beverages",
    image: "/assets/Beverages/Amla_Immunity_Booster.Main.180.png",
    images: [
      "/assets/Beverages/Amla_Immunity_Booster.PC.jpeg",
      "/assets/Beverages/Amla_Immunity_Booster.Main.180.png",
      "/assets/Beverages/Amla_Immunity_Booster.Back.png",
    ],
    price: 225,
    offerPrice: 225,
    variants: [{ size: "100g", price: 225, offerPrice: 225 }],
    description: "Natural amla-based immunity booster for daily wellness.",
    details: "Rich in Vitamin C. Supports immune system health.",
    rating: 4.7,
    inStock: true,
  },
  {
    id: 2,
    name: "Ash Gourd Juice",
    category: "beverages",
    image: "/assets/Beverages/Ash_Gourd_Juice.Main.180.png",
    images: [
      "/assets/Beverages/Ash_Gourd_Juice.Main.180.png",
      "/assets/Beverages/Ash_Gourd_Juice.Back.png",
    ],
    price: 225,
    offerPrice: 225,
    variants: [{ size: "100g", price: 225, offerPrice: 225 }],
    description: "Refreshing and healthy ash gourd juice.",
    details: "Natural cooling properties. Good for digestion.",
    rating: 4.5,
    inStock: true,
  },
  {
    id: 3,
    name: "Banana Stem Soup",
    category: "beverages",
    image: "/assets/Beverages/Banana_Stem_Soup.Main.180.png",
    images: [
      "/assets/Beverages/Banana_Stem_Soup.Main.180.png",
      "/assets/Beverages/Banana_Stem_Soup.Back.png",
    ],
    price: 200,
    offerPrice: 200,
    variants: [{ size: "100g", price: 200, offerPrice: 200 }],
    description: "Nutritious banana stem soup mix.",
    details: "High in fiber. Supports kidney health.",
    rating: 4.6,
    inStock: true,
  },

  {
    id: 4,
    name: "Moringa Soup Blend",
    category: "beverages",
    image: "/assets/Beverages/Moringa_Soup_Blend.Main.180.png",
    images: [
      "/assets/Beverages/Moringa_Soup_Blend.PC.jpeg",
      "/assets/Beverages/Moringa_Soup_Blend.Main.180.png",
      "/assets/Beverages/Moringa_Soup_Blend.Back.png",
    ],
    price: 180,
    offerPrice: 180,
    variants: [{ size: "100g", price: 180, offerPrice: 180 }],
    description: "Nutrient-rich moringa soup blend.",
    details: "Packed with vitamins and minerals. Superfood blend.",
    rating: 4.8,
    inStock: true,
  },
  {
    id: 5,
    name: "Sukku Malli Coffee",
    category: "beverages",
    image: "/assets/Beverages/Sukku_Malli_Coffee.Main.149.png",
    images: [
      "/assets/Beverages/Sukku_Malli_Coffee.PC.jpeg",
      "/assets/Beverages/Sukku_Malli_Coffee.Main.149.png",
      "/assets/Beverages/Sukku_Malli_Coffee.Back.png",
    ],
    price: 180,
    offerPrice: 180,
    variants: [{ size: "200g", price: 180, offerPrice: 180 }],
    description: "Traditional sukku malli coffee blend.",
    details: "Aromatic and healthy. Good for digestion.",
    rating: 4.7,
    inStock: true,
  },

  // Ghee and Oil
  {
    id: 6,
    name: "Cold Pressed Coconut Oil",
    category: "ghee-and-oil",
    image: "/assets/GheeAndOil/Cold_Pressed_Coconut_Oil.Main.449.png",
    images: ["/assets/GheeAndOil/Cold_Pressed_Coconut_Oil.Main.449.png"],
    price: 550,
    offerPrice: 550,
    variants: [
      { size: "500ml", price: 275, offerPrice: 275 },
      { size: "1L", price: 550, offerPrice: 550 },
    ],
    description: "Pure cold-pressed coconut oil.",
    details: "100% natural. No chemicals or preservatives.",
    rating: 4.9,
    inStock: true,
  },
  {
    id: 7,
    name: "Cold Pressed Groundnut Oil",
    category: "ghee-and-oil",
    image: "/assets/GheeAndOil/Cold_Pressed_Groundnut_Oil.Main.280.png",
    images: ["/assets/GheeAndOil/Cold_Pressed_Groundnut_Oil.Main.280.png"],
    price: 350,
    offerPrice: 350,
    variants: [
      { size: "500ml", price: 175, offerPrice: 175 },
      { size: "1L", price: 350, offerPrice: 350 },
    ],
    description: "Premium cold-pressed groundnut oil.",
    details: "Rich in healthy fats. Perfect for cooking.",
    rating: 4.8,
    inStock: true,
  },

  {
    id: 8,
    name: "Cold Pressed Sesame Oil",
    category: "ghee-and-oil",
    image: "/assets/GheeAndOil/Cold_Pressed_Sesame_Oil.Main.329.png",
    images: ["/assets/GheeAndOil/Cold_Pressed_Sesame_Oil.Main.329.png"],
    price: 450,
    offerPrice: 450,
    variants: [
      { size: "500ml", price: 225, offerPrice: 225 },
      { size: "1L", price: 450, offerPrice: 450 },
    ],
    description: "Traditional cold-pressed sesame oil.",
    details: "Rich aroma. Ideal for South Indian cooking.",
    rating: 4.8,
    inStock: true,
  },
  {
    id: 9,
    name: "Pure Cow Ghee",
    category: "ghee-and-oil",
    image: "/assets/GheeAndOil/Pure_Cow_Ghee.Main.699.png",
    images: [
      "/assets/GheeAndOil/Pure_Cow_Ghee.Main.699.png",
      "/assets/GheeAndOil/Pure_Cow_Ghee.Back.png",
    ],
    price: 400,
    offerPrice: 400,
    variants: [
      { size: "250ml", price: 200, offerPrice: 200 },
      { size: "500ml", price: 400, offerPrice: 400 },
      { size: "1L", price: 800, offerPrice: 800 },
    ],
    description: "Premium quality pure cow ghee.",
    details: "Made from pure cow milk. Rich in nutrients.",
    rating: 5.0,
    inStock: true,
  },

  // Malt and Health Mix
  {
    id: 10,
    name: "ABC Malt",
    category: "malt-and-health-mix",
    image: "/assets/MaltAndHealthMix/ABC_Malt.Main.249.png",
    images: [
      "/assets/MaltAndHealthMix/ABC_Malt.PC.jpeg",
      "/assets/MaltAndHealthMix/ABC_Malt.Main.249.png",
      "/assets/MaltAndHealthMix/ABC_Malt.Black.png",
    ],
    price: 300,
    offerPrice: 300,
    variants: [
      { size: "200g", price: 300, offerPrice: 300 },
      { size: "500g", price: 750, offerPrice: 750 },
    ],
    description: "Nutritious ABC malt for overall health.",
    details: "Rich in vitamins and minerals. Great for kids.",
    rating: 4.7,
    inStock: true,
  },

  {
    id: 11,
    name: "Country Fig Malt",
    category: "malt-and-health-mix",
    image: "/assets/MaltAndHealthMix/Country_Fig_Malt.Main.249.png",
    images: [
      "/assets/MaltAndHealthMix/Country_Fig_Malt.PC.jpeg",
      "/assets/MaltAndHealthMix/Country_Fig_Malt.Main.249.png",
      "/assets/MaltAndHealthMix/Country_Fig_Malt.Back.png",
    ],
    price: 300,
    offerPrice: 300,
    variants: [
      { size: "100g", price: 300, offerPrice: 300 },
      { size: "200g", price: 600, offerPrice: 600 },
    ],
    description: "Delicious country fig malt.",
    details: "Natural sweetness. High in fiber.",
    rating: 4.8,
    inStock: true,
  },
  {
    id: 12,
    name: "Country Guava Malt",
    category: "malt-and-health-mix",
    image: "/assets/MaltAndHealthMix/Country_Guava_Malt.Main.249.png",
    images: [
      "/assets/MaltAndHealthMix/Country_Guava_Malt.PC.jpeg",
      "/assets/MaltAndHealthMix/Country_Guava_Malt.Main.249.png",
      "/assets/MaltAndHealthMix/Country_Guava_Malt.Back.png",
    ],
    price: 300,
    offerPrice: 300,
    variants: [
      { size: "100g", price: 300, offerPrice: 300 },
      { size: "200g", price: 600, offerPrice: 600 },
    ],
    description: "Refreshing country guava malt.",
    details: "Rich in Vitamin C. Natural flavor.",
    rating: 4.7,
    inStock: true,
  },
  {
    id: 13,
    name: "Natural Digest O Care",
    category: "malt-and-health-mix",
    image: "/assets/MaltAndHealthMix/Natural_Digest_O_Care.Main.149.png",
    images: [
      "/assets/MaltAndHealthMix/Natural_Digest_O_Care.PC.jpeg",
      "/assets/MaltAndHealthMix/Natural_Digest_O_Care.Main.149.png",
      "/assets/MaltAndHealthMix/Natural_Digest_O_Care.Back.png",
    ],
    price: 180,
    offerPrice: 180,
    variants: [
      { size: "200g", price: 180, offerPrice: 180 },
      { size: "500g", price: 450, offerPrice: 450 },
    ],
    description: "Natural digestive care supplement.",
    details: "Supports healthy digestion. Natural ingredients.",
    rating: 4.6,
    inStock: true,
  },

  {
    id: 14,
    name: "Natural Weight Loss Soup Mix",
    category: "malt-and-health-mix",
    image: "/assets/MaltAndHealthMix/Natural_Weight_Loss_Soup_Mix.Main.149.png",
    images: [
      "/assets/MaltAndHealthMix/Natural_Weight_Loss_Soup_Mix.PC.jpeg",
      "/assets/MaltAndHealthMix/Natural_Weight_Loss_Soup_Mix.Main.149.png",
      "/assets/MaltAndHealthMix/Natural_Weight_Loss_Soup_Mix.Back.png",
    ],
    price: 180,
    offerPrice: 180,
    variants: [
      { size: "250g", price: 180, offerPrice: 180 },
      { size: "500g", price: 360, offerPrice: 360 },
    ],
    description: "Natural weight loss soup mix.",
    details: "Low calorie. High in nutrients.",
    rating: 4.5,
    inStock: true,
  },
  {
    id: 15,
    name: "Nendran Banana Malt",
    category: "malt-and-health-mix",
    image: "/assets/MaltAndHealthMix/Nendran_Banana_Malt.Main.249.png",
    images: [
      "/assets/MaltAndHealthMix/Nendran_Banana_Malt.PC.jpeg",
      "/assets/MaltAndHealthMix/Nendran_Banana_Malt.Main.249.png",
      "/assets/MaltAndHealthMix/Nendran_Banana_Malt.Back.png",
    ],
    price: 300,
    offerPrice: 300,
    variants: [
      { size: "200g", price: 300, offerPrice: 300 },
      { size: "500g", price: 750, offerPrice: 750 },
    ],
    description: "Traditional nendran banana malt.",
    details: "Rich in potassium. Natural energy booster.",
    rating: 4.8,
    inStock: true,
  },
  {
    id: 16,
    name: "Palmyra Sprout Powder",
    category: "malt-and-health-mix",
    image: "/assets/MaltAndHealthMix/Palmyra_Sprout_Powder.Main.699.png",
    images: [
      "/assets/MaltAndHealthMix/Palmyra_Sprout_Powder.PC.jpeg",
      "/assets/MaltAndHealthMix/Palmyra_Sprout_Powder.Main.699.png",
    ],
    price: 200,
    offerPrice: 200,
    variants: [
      { size: "200g", price: 200, offerPrice: 200 },
      { size: "500g", price: 500, offerPrice: 500 },
    ],
    description: "Premium palmyra sprout powder.",
    details: "Rare and nutritious. Traditional superfood.",
    rating: 4.9,
    inStock: true,
  },

  {
    id: 17,
    name: "Ragi Chocolate Malt",
    category: "malt-and-health-mix",
    image: "/assets/MaltAndHealthMix/Ragi_Chocolate_Malt.Main.249.png",
    images: [
      "/assets/MaltAndHealthMix/Ragi_Chocolate_Malt.PC.jpeg",
      "/assets/MaltAndHealthMix/Ragi_Chocolate_Malt.Main.249.png",
      "/assets/MaltAndHealthMix/Ragi_Chocolate_Malt.Back.png",
    ],
    price: 300,
    offerPrice: 300,
    variants: [
      { size: "200g", price: 300, offerPrice: 300 },
      { size: "500g", price: 750, offerPrice: 750 },
    ],
    description: "Delicious ragi chocolate malt.",
    details: "High in calcium. Kids favorite.",
    rating: 4.9,
    inStock: true,
  },
  {
    id: 18,
    name: "Red Banana Malt",
    category: "malt-and-health-mix",
    image: "/assets/MaltAndHealthMix/Red_Banana_Malt.Main.249.png",
    images: [
      "/assets/MaltAndHealthMix/Red_Banana_Malt.PC.jpeg",
      "/assets/MaltAndHealthMix/Red_Banana_Malt.Main.249.png",
      "/assets/MaltAndHealthMix/Red_Banana_Malt.Back.png",
    ],
    price: 300,
    offerPrice: 300,
    variants: [
      { size: "200g", price: 300, offerPrice: 300 },
      { size: "500g", price: 750, offerPrice: 750 },
    ],
    description: "Nutritious red banana malt.",
    details: "Rich in antioxidants. Natural sweetness.",
    rating: 4.7,
    inStock: true,
  },
  {
    id: 19,
    name: "Ragi Urad BoneShield",
    category: "malt-and-health-mix",
    image: "/assets/MaltAndHealthMix/Ragi_Urad_BoneShield.Main.jpeg",
    images: [
      "/assets/MaltAndHealthMix/Ragi_Urad_BoneShield.Main.jpeg",
      "/assets/MaltAndHealthMix/Ragi_Urad_BoneShield.Back.jpeg",
    ],
    price: 200,
    offerPrice: 200,
    variants: [
      { size: "250g", price: 200, offerPrice: 200 },
      { size: "500g", price: 400, offerPrice: 400 },
    ],
    description: "Ragi Urad BoneShield.",
    details: "Black urad and Ragi, helping support bones.",
    rating: 4.8,
    inStock: true,
  },

  {
    id: 20,
    name: "Natural NutriFizz",
    category: "malt-and-health-mix",
    image: "/assets/MaltAndHealthMix/Natural_NutriFizz.Main.jpeg",
    images: [
      "/assets/MaltAndHealthMix/Natural_NutriFizz.Main.jpeg",
      "/assets/MaltAndHealthMix/Natural_NutriFizz.Back.jpeg",
    ],
    price: 300,
    offerPrice: 300,
    variants: [{ size: "100g", price: 300, offerPrice: 300 }],
    description: "Natural NutriFizz.",
    details: "IMMUNITY & HEMOGLOBIN BOOSTER.",
    rating: 4.8,
    inStock: true,
  },
  {
    id: 21,
    name: "Natural Glowfizz",
    category: "malt-and-health-mix",
    image: "/assets/MaltAndHealthMix/Natural_Glowfizz.Main.jpeg",
    images: [
      "/assets/MaltAndHealthMix/Natural_Glowfizz.Main.jpeg",
      "/assets/MaltAndHealthMix/Natural_Glowfizz.Back.jpeg",
    ],
    price: 300,
    offerPrice: 300,
    variants: [{ size: "100g", price: 300, offerPrice: 300 }],
    description: "Natural Glowfizz.",
    details: "SKIN GLOW & HEMOGLOBIN BOOSTER.",
    rating: 4.8,
    inStock: true,
  },

  // Palm Products
  {
    id: 22,
    name: "Karupatti",
    category: "palm-products",
    image: "/assets/PalmProducts/Karupatti.Main.599.png",
    images: ["/assets/PalmProducts/Karupatti.Main.599.png"],
    price: 500,
    offerPrice: 500,
    variants: [
      { size: "500g", price: 250, offerPrice: 250 },
      { size: "1kg", price: 500, offerPrice: 500 },
    ],
    description: "Pure palm jaggery (Karupatti).",
    details: "Natural sweetener. Rich in minerals.",
    rating: 4.9,
    inStock: true,
  },

  {
    id: 23,
    name: "Karupatti Instant Coffee Powder",
    category: "palm-products",
    image: "/assets/PalmProducts/Karupatti_Instant_Coffee_Powder.Main.149.png",
    images: [
      "/assets/PalmProducts/Karupatti_Instant_Coffee_Powder.Main.149.png",
    ],
    price: 190,
    offerPrice: 190,
    variants: [{ size: "200g", price: 190, offerPrice: 190 }],
    description: "Instant coffee with palm jaggery.",
    details: "Healthy alternative to regular coffee. Natural sweetness.",
    rating: 4.7,
    inStock: true,
  },
  {
    id: 24,
    name: "Karupatti Powder",
    category: "palm-products",
    image: "/assets/PalmProducts/Karupatti_Powder.Main.149.png",
    images: ["/assets/PalmProducts/Karupatti_Powder.Main.149.png"],
    price: 190,
    offerPrice: 190,
    variants: [{ size: "200g", price: 190, offerPrice: 190 }],
    description: "Palm jaggery powder.",
    details: "Easy to use. Natural sweetener.",
    rating: 4.8,
    inStock: true,
  },
  {
    id: 25,
    name: "Karupatti Sukku Malli Coffee",
    category: "palm-products",
    image: "/assets/PalmProducts/Karupatti_Sukku_Malli_Coffee.Main.149.png",
    images: ["/assets/PalmProducts/Karupatti_Sukku_Malli_Coffee.Main.149.png"],
    price: 190,
    offerPrice: 190,
    variants: [{ size: "200g", price: 190, offerPrice: 190 }],
    description: "Traditional sukku malli coffee with palm jaggery.",
    details: "Aromatic and healthy. Good for digestion.",
    rating: 4.8,
    inStock: true,
  },
  {
    id: 26,
    name: "Palm Brinjal Jam",
    category: "palm-products",
    image: "/assets/PalmProducts/Palm_Brinjal_Jam.Main.899.png",
    images: ["/assets/PalmProducts/Palm_Brinjal_Jam.Main.899.png"],
    price: 200,
    offerPrice: 200,
    variants: [
      { size: "150g", price: 200, offerPrice: 200 },
      { size: "250g", price: 333, offerPrice: 333 },
      { size: "500g", price: 667, offerPrice: 667 },
    ],
    description: "Unique palm brinjal jam.",
    details: "Traditional recipe. Exotic flavor.",
    rating: 4.6,
    inStock: true,
  },

  {
    id: 27,
    name: "Palm Candy",
    category: "palm-products",
    image: "/assets/PalmProducts/Palm_Candy.Main.799.png",
    images: ["/assets/PalmProducts/Palm_Candy.Main.799.png"],
    price: 250,
    offerPrice: 250,
    variants: [
      { size: "250g", price: 250, offerPrice: 250 },
      { size: "500g", price: 500, offerPrice: 500 },
      { size: "1kg", price: 1000, offerPrice: 1000 },
    ],
    description: "Natural palm candy.",
    details: "Traditional sweet. Pure and natural.",
    rating: 4.8,
    inStock: true,
  },
  {
    id: 28,
    name: "Palm Jaggery Syrup",
    category: "palm-products",
    image: "/assets/PalmProducts/Palm_Jaggery_Syrup.Main.799.png",
    images: [
      "/assets/PalmProducts/Palm_Jaggery_Syrup.Main.799.png",
      "/assets/PalmProducts/Palm_Jaggery_Syrup.back.png",
    ],
    price: 400,
    offerPrice: 400,
    variants: [
      { size: "250g", price: 200, offerPrice: 200 },
      { size: "500g", price: 400, offerPrice: 400 },
      { size: "1kg", price: 800, offerPrice: 800 },
    ],
    description: "Pure palm jaggery syrup.",
    details: "Liquid sweetener. Rich in minerals.",
    rating: 4.9,
    inStock: true,
  },
  {
    id: 29,
    name: "Palm Moongdal Jam",
    category: "palm-products",
    image: "/assets/PalmProducts/Palm_Moongdal_Jam.Main.899.png",
    images: ["/assets/PalmProducts/Palm_Moongdal_Jam.Main.899.png"],
    price: 200,
    offerPrice: 200,
    variants: [
      { size: "150g", price: 200, offerPrice: 200 },
      { size: "250g", price: 333, offerPrice: 333 },
      { size: "500g", price: 667, offerPrice: 667 },
    ],
    description: "Traditional palm moongdal jam.",
    details: "Unique flavor. High in protein.",
    rating: 4.7,
    inStock: true,
  },

  {
    id: 30,
    name: "Palm Peanut Bites",
    category: "palm-products",
    image: "/assets/PalmProducts/Palm_Peanut_Bites.649.png",
    images: ["/assets/PalmProducts/Palm_Peanut_Bites.649.png"],
    price: 200,
    offerPrice: 200,
    variants: [
      { size: "250g", price: 200, offerPrice: 200 },
      { size: "500g", price: 400, offerPrice: 400 },
      { size: "1kg", price: 800, offerPrice: 800 },
    ],
    description: "Crunchy palm peanut bites.",
    details: "Healthy snack. Natural sweetness.",
    rating: 4.8,
    inStock: true,
  },
  {
    id: 31,
    name: "Palm Pumpkin Jam",
    category: "palm-products",
    image: "/assets/PalmProducts/Palm_Pumpkin_Jam.Main.899.png",
    images: ["/assets/PalmProducts/Palm_Pumpkin_Jam.Main.899.png"],
    price: 200,
    offerPrice: 200,
    variants: [
      { size: "150g", price: 200, offerPrice: 200 },
      { size: "250g", price: 333, offerPrice: 333 },
      { size: "500g", price: 667, offerPrice: 667 },
    ],
    description: "Delicious palm pumpkin jam.",
    details: "Traditional recipe. Rich in vitamins.",
    rating: 4.7,
    inStock: true,
  },
  {
    id: 32,
    name: "Panankarkandu Sukku Malli Coffee",
    category: "palm-products",
    image: "/assets/PalmProducts/Panankarkandu_Sukku_Malli_Coffee.Main.149.png",
    images: [
      "/assets/PalmProducts/Panankarkandu_Sukku_Malli_Coffee.Main.149.png",
    ],
    price: 190,
    offerPrice: 190,
    variants: [{ size: "200g", price: 190, offerPrice: 190 }],
    description: "Traditional coffee with palm candy.",
    details: "Aromatic and healthy. Natural sweetness.",
    rating: 4.8,
    inStock: true,
  },
  {
    id: 33,
    name: "Panankarkandu Sukku Malli Pal",
    category: "palm-products",
    image: "/assets/PalmProducts/Panankarkandu_Sukku_Malli_Pal.Main.149.png",
    images: ["/assets/PalmProducts/Panankarkandu_Sukku_Malli_Pal.Main.149.png"],
    price: 190,
    offerPrice: 190,
    variants: [{ size: "200g", price: 190, offerPrice: 190 }],
    description: "Traditional milk blend with palm candy.",
    details: "Healthy and delicious. Good for digestion.",
    rating: 4.7,
    inStock: true,
  },

  // Rice Millets
  {
    id: 34,
    name: "Black Kavuni Dosa Blend",
    category: "rice-millets",
    image: "/assets/RiceMillets/Black_Kavuni_Dosa_Blend.Main.125.png",
    images: [
      "/assets/RiceMillets/Black_Kavuni_Dosa_Blend.PC.jpeg",
      "/assets/RiceMillets/Black_Kavuni_Dosa_Blend.Main.125.png",
      "/assets/RiceMillets/Black_Kavuni_Dosa_Blend.Back.png",
    ],
    price: 160,
    offerPrice: 160,
    variants: [
      { size: "250g", price: 160, offerPrice: 160 },
      { size: "500g", price: 320, offerPrice: 320 },
    ],
    description: "Premium black kavuni rice dosa blend.",
    details: "Rich in antioxidants. Traditional recipe.",
    rating: 4.8,
    inStock: true,
  },
  {
    id: 35,
    name: "Black Urad Kavuni Kanji Mix",
    category: "rice-millets",
    image: "/assets/RiceMillets/Black_Urad_Kavuni_Kanji_Mix.Main.170.png",
    images: [
      "/assets/RiceMillets/Black_Urad_Kavuni_Kanji_Mix.PC.jpeg",
      "/assets/RiceMillets/Black_Urad_Kavuni_Kanji_Mix.Main.170.png",
    ],
    price: 180,
    offerPrice: 180,
    variants: [
      { size: "250g", price: 180, offerPrice: 180 },
      { size: "500g", price: 360, offerPrice: 360 },
    ],
    description: "Nutritious black urad kavuni kanji mix.",
    details: "High in protein. Easy to prepare.",
    rating: 4.7,
    inStock: true,
  },
  {
    id: 36,
    name: "Bride Groom Dosa Blend",
    category: "rice-millets",
    image: "/assets/RiceMillets/Bride_Groom_Dosa_Blend.Main.125.png",
    images: [
      "/assets/RiceMillets/Bride_Groom_Dosa_Blend.PC.jpeg",
      "/assets/RiceMillets/Bride_Groom_Dosa_Blend.Main.125.png",
      "/assets/RiceMillets/Bride_Groom_Dosa_Blend.Back.png",
    ],
    price: 160,
    offerPrice: 160,
    variants: [
      { size: "250g", price: 160, offerPrice: 160 },
      { size: "500g", price: 320, offerPrice: 320 },
    ],
    description: "Special bride groom dosa blend.",
    details: "Traditional recipe. Perfect for special occasions.",
    rating: 4.9,
    inStock: true,
  },

  {
    id: 37,
    name: "Kuthiraivali Pongal Mix",
    category: "rice-millets",
    image: "/assets/RiceMillets/Kuthiraivali_Pongal_Mix.Main.125.png",
    images: [
      "/assets/RiceMillets/Kuthiraivali_Pongal_Mix.PC.jpeg",
      "/assets/RiceMillets/Kuthiraivali_Pongal_Mix.Main.125.png",
      "/assets/RiceMillets/Kuthiraivali_Pongal_Mix.Back.png",
    ],
    price: 160,
    offerPrice: 160,
    variants: [
      { size: "250g", price: 160, offerPrice: 160 },
      { size: "500g", price: 320, offerPrice: 320 },
    ],
    description: "Healthy kuthiraivali pongal mix.",
    details: "Millet-based. Nutritious breakfast option.",
    rating: 4.7,
    inStock: true,
  },
  {
    id: 38,
    name: "Moringa Kichali Samba Porridge",
    category: "rice-millets",
    image: "/assets/RiceMillets/Moringa_Kichali_Samba_Porridge.Main.149.png",
    images: [
      "/assets/RiceMillets/Moringa_Kichali_Samba_Porridge.PC.jpeg",
      "/assets/RiceMillets/Moringa_Kichali_Samba_Porridge.Main.149.png",
    ],
    price: 225,
    offerPrice: 225,
    variants: [{ size: "250g", price: 225, offerPrice: 225 }],
    description: "Moringa-infused kichali samba porridge.",
    details: "Superfood blend. Rich in nutrients.",
    rating: 4.8,
    inStock: true,
  },
  {
    id: 39,
    name: "Moringa Milagu Samba Porridge",
    category: "rice-millets",
    image: "/assets/RiceMillets/Moringa_Milagu_samba_Porridge.Main.149.png",
    images: [
      "/assets/RiceMillets/Moringa_Milagu_samba_Porridge.PC.jpeg",
      "/assets/RiceMillets/Moringa_Milagu_samba_Porridge.Main.149.png",
    ],
    price: 225,
    offerPrice: 225,
    variants: [{ size: "250g", price: 225, offerPrice: 225 }],
    description: "Moringa milagu samba porridge.",
    details: "Spiced and nutritious. Traditional flavor.",
    rating: 4.7,
    inStock: true,
  },

  {
    id: 40,
    name: "Moringa Seeraga Samba Porridge",
    category: "rice-millets",
    image: "/assets/RiceMillets/Moringa_Seeraga_Samba_Porridge.Main.149.png",
    images: [
      "/assets/RiceMillets/Moringa_Seeraga_Samba_Porridge.PC.jpeg",
      "/assets/RiceMillets/Moringa_Seeraga_Samba_Porridge.Main.149.png",
    ],
    price: 225,
    offerPrice: 225,
    variants: [{ size: "250g", price: 225, offerPrice: 225 }],
    description: "Moringa seeraga samba porridge.",
    details: "Aromatic rice blend. Nutrient-rich.",
    rating: 4.8,
    inStock: true,
  },
  {
    id: 41,
    name: "Moringa Thooya Malli Porridge",
    category: "rice-millets",
    image: "/assets/RiceMillets/Moringa_Thooya_Malli_Porridge.Main.149.png",
    images: [
      "/assets/RiceMillets/Moringa_Thooya_Malli_Porridge.PC.jpeg",
      "/assets/RiceMillets/Moringa_Thooya_Malli_Porridge.Main.149.png",
    ],
    price: 225,
    offerPrice: 225,
    variants: [{ size: "250g", price: 225, offerPrice: 225 }],
    description: "Moringa thooya malli porridge.",
    details: "Healthy breakfast option. Easy to prepare.",
    rating: 4.7,
    inStock: true,
  },
  {
    id: 42,
    name: "Multi Millet Nutri Force Premium",
    category: "rice-millets",
    image: "/assets/RiceMillets/Multi_Millet_Nutri_Force_Premium.Main.225.png",
    images: [
      "/assets/RiceMillets/Multi_Millet_Nutri_Force_Premium.Main.225.png",
      "/assets/RiceMillets/Multi_Millet_Nutri_Force_Premium.Back.png",
    ],
    price: 250,
    offerPrice: 250,
    variants: [
      { size: "250g", price: 250, offerPrice: 250 },
      { size: "500g", price: 500, offerPrice: 500 },
    ],
    description: "Premium multi millet blend.",
    details: "Complete nutrition. Multiple millets combined.",
    rating: 4.9,
    inStock: true,
  },

  {
    id: 43,
    name: "Multi Millet Nutriforce Blend",
    category: "rice-millets",
    image: "/assets/RiceMillets/Multi_Millet_Nutriforce_Blend.Main.170.png",
    images: [
      "/assets/RiceMillets/Multi_Millet_Nutriforce_Blend.PC.jpeg",
      "/assets/RiceMillets/Multi_Millet_Nutriforce_Blend.Main.170.png",
      "/assets/RiceMillets/Multi_Millet_Nutriforce_Blend.back.png",
    ],
    price: 180,
    offerPrice: 180,
    variants: [
      { size: "250g", price: 180, offerPrice: 180 },
      { size: "500g", price: 360, offerPrice: 360 },
    ],
    description: "Multi millet nutriforce blend.",
    details: "Balanced nutrition. Great for all ages.",
    rating: 4.8,
    inStock: true,
  },
  {
    id: 44,
    name: "Sourgum Dosa Blend",
    category: "rice-millets",
    image: "/assets/RiceMillets/Sourgum_Dosa_Blend.Main.125.png",
    images: [
      "/assets/RiceMillets/Sourgum_Dosa_Blend.PC.jpeg",
      "/assets/RiceMillets/Sourgum_Dosa_Blend.Main.125.png",
      "/assets/RiceMillets/Sourgum_Dosa_Blend.Back.125.png",
    ],
    price: 160,
    offerPrice: 160,
    variants: [
      { size: "250g", price: 160, offerPrice: 160 },
      { size: "500g", price: 320, offerPrice: 320 },
    ],
    description: "Healthy sourgum dosa blend.",
    details: "Millet-based. Crispy dosas.",
    rating: 4.7,
    inStock: true,
  },
  {
    id: 45,
    name: "Thinai Pongal Mix",
    category: "rice-millets",
    image: "/assets/RiceMillets/Thinai_Pongal_Mix.Main.125.png",
    images: [
      "/assets/RiceMillets/Thinai_Pongal_Mix.PC.jpeg",
      "/assets/RiceMillets/Thinai_Pongal_Mix.Main.125.png",
      "/assets/RiceMillets/Thinai_Pongal_Mix.Back.png",
    ],
    price: 160,
    offerPrice: 160,
    variants: [
      { size: "250g", price: 160, offerPrice: 160 },
      { size: "500g", price: 320, offerPrice: 320 },
    ],
    description: "Traditional thinai pongal mix.",
    details: "Foxtail millet. Nutritious and delicious.",
    rating: 4.8,
    inStock: true,
  },

  {
    id: 46,
    name: "Varagu Pongal Mix",
    category: "rice-millets",
    image: "/assets/RiceMillets/Varagu_Pongal_Mix.Main.125.png",
    images: [
      "/assets/RiceMillets/Varagu_Pongal_Mix.PC.jpeg",
      "/assets/RiceMillets/Varagu_Pongal_Mix.Main.125.png",
      "/assets/RiceMillets/Varagu_Pongal_Mix.Back.png",
    ],
    price: 160,
    offerPrice: 160,
    variants: [
      { size: "250g", price: 160, offerPrice: 160 },
      { size: "500g", price: 320, offerPrice: 320 },
    ],
    description: "Healthy varagu pongal mix.",
    details: "Kodo millet. Easy to digest.",
    rating: 4.7,
    inStock: true,
  },

  // Tiffin
  {
    id: 47,
    name: "Aloo Masala Atta",
    category: "tiffin",
    image: "/assets/Tiffin/Aloo_Masala_Atta.Main.125.png",
    images: [
      "/assets/Tiffin/Aloo_Masala_Atta.PC.jpeg",
      "/assets/Tiffin/Aloo_Masala_Atta.Main.125.png",
    ],
    price: 160,
    offerPrice: 160,
    variants: [
      { size: "250g", price: 160, offerPrice: 160 },
      { size: "500g", price: 320, offerPrice: 320 },
      { size: "1kg", price: 640, offerPrice: 640 },
    ],
    description: "Spiced aloo masala atta.",
    details: "Perfect for parathas. Ready-to-use blend.",
    rating: 4.6,
    inStock: true,
  },
  {
    id: 48,
    name: "Beetroot Atta",
    category: "tiffin",
    image: "/assets/Tiffin/Beetroot_Atta.Main.125.jpeg",
    images: [
      "/assets/Tiffin/Beetroot_Atta.PC.jpeg",
      "/assets/Tiffin/Beetroot_Atta.Main.125.jpeg",
      "/assets/Tiffin/Beetroot_Atta.Back.jpeg",
    ],
    price: 160,
    offerPrice: 160,
    variants: [
      { size: "250g", price: 160, offerPrice: 160 },
      { size: "500g", price: 320, offerPrice: 320 },
      { size: "1kg", price: 640, offerPrice: 640 },
    ],
    description: "Nutritious beetroot atta.",
    details: "Rich in iron. Natural color.",
    rating: 4.7,
    inStock: true,
  },

  {
    id: 49,
    name: "Carrot Atta",
    category: "tiffin",
    image: "/assets/Tiffin/Carrot_Atta.Main.125.png",
    images: [
      "/assets/Tiffin/Carrot_Atta.PC.jpeg",
      "/assets/Tiffin/Carrot_Atta.Main.125.jpeg",
      "/assets/Tiffin/Carrot_Atta.Back.jpeg",
    ],
    price: 160,
    offerPrice: 160,
    variants: [
      { size: "250g", price: 160, offerPrice: 160 },
      { size: "500g", price: 320, offerPrice: 320 },
      { size: "1kg", price: 640, offerPrice: 640 },
    ],
    description: "Healthy carrot atta.",
    details: "Rich in Vitamin A. Kids favorite.",
    rating: 4.7,
    inStock: true,
  },
  {
    id: 50,
    name: "Moringa Atta",
    category: "tiffin",
    image: "/assets/Tiffin/Moringa_Atta.Main.125.png",
    images: [
      "/assets/Tiffin/Moringa_Atta.PC.jpeg",
      "/assets/Tiffin/Moringa_Atta.Main.125.png",
      "/assets/Tiffin/Moringa_Atta.Back.png",
    ],
    price: 160,
    offerPrice: 160,
    variants: [
      { size: "250g", price: 160, offerPrice: 160 },
      { size: "500g", price: 320, offerPrice: 320 },
      { size: "1kg", price: 640, offerPrice: 640 },
    ],
    description: "Superfood moringa atta.",
    details: "Nutrient-dense. Healthy choice.",
    rating: 4.8,
    inStock: true,
  },
  {
    id: 51,
    name: "Palak Atta",
    category: "tiffin",
    image: "/assets/Tiffin/Palak_Atta.Main.125.png",
    images: [
      "/assets/Tiffin/Palak_Atta.PC.jpeg",
      "/assets/Tiffin/Palak_Atta.Main.125.png",
      "/assets/Tiffin/Palak_Atta.Back.png",
    ],
    price: 160,
    offerPrice: 160,
    variants: [
      { size: "250g", price: 160, offerPrice: 160 },
      { size: "500g", price: 320, offerPrice: 320 },
      { size: "1kg", price: 640, offerPrice: 640 },
    ],
    description: "Nutritious palak (spinach) atta.",
    details: "Rich in iron. Healthy and tasty.",
    rating: 4.7,
    inStock: true,
  },

  {
    id: 52,
    name: "Pumpkin Atta",
    category: "tiffin",
    image: "/assets/Tiffin/Pumpkin_Atta.Main.125.png",
    images: [
      "/assets/Tiffin/Pumpkin_Atta.PC.jpeg",
      "/assets/Tiffin/Pumpkin_Atta.Main.125.png",
      "/assets/Tiffin/Pumpkin_Atta.Back.png",
    ],
    price: 160,
    offerPrice: 160,
    variants: [
      { size: "250g", price: 160, offerPrice: 160 },
      { size: "500g", price: 320, offerPrice: 320 },
      { size: "1kg", price: 640, offerPrice: 640 },
    ],
    description: "Healthy pumpkin atta.",
    details: "Rich in vitamins. Natural sweetness.",
    rating: 4.6,
    inStock: true,
  },
  {
    id: 53,
    name: "Sweet Potato Atta",
    category: "tiffin",
    image: "/assets/Tiffin/Sweet_Potato_Atta.Main.125.jpeg",
    images: [
      "/assets/Tiffin/Sweet_Potato_Atta.Main.125.jpeg",
      "/assets/Tiffin/Sweet_Potato_Atta.Back.jpeg",
    ],
    price: 160,
    offerPrice: 160,
    variants: [
      { size: "250g", price: 160, offerPrice: 160 },
      { size: "500g", price: 320, offerPrice: 320 },
      { size: "1kg", price: 640, offerPrice: 640 },
    ],
    description: "Healthy sweet potato atta.",
    details: "Rich in vitamins. Natural sweetness.",
    rating: 4.6,
    inStock: true,
  },
  {
    id: 54,
    name: "Beetroot Noodles",
    category: "tiffin",
    image: "/assets/Tiffin/Beetroot_Noodles.Main.jpeg",
    images: [
      "/assets/Tiffin/Beetroot_Noodles.Main.jpeg",
      "/assets/Tiffin/Beetroot_Noodles.Back.jpeg",
    ],
    price: 175,
    offerPrice: 175,
    variants: [{ size: "250g", price: 175, offerPrice: 175 }],
    description: "Healthy Beetroot Noodles.",
    details: "Rich in iron. Natural color.",
    rating: 4.6,
    inStock: true,
  },

  {
    id: 55,
    name: "Carrot Noodles",
    category: "tiffin",
    image: "/assets/Tiffin/Carrot_Noodles.Main.jpeg",
    images: [
      "/assets/Tiffin/Carrot_Noodles.Main.jpeg",
      "/assets/Tiffin/Carrot_Noodles.Back.jpeg",
    ],
    price: 175,
    offerPrice: 175,
    variants: [{ size: "250g", price: 175, offerPrice: 175 }],
    description: "Healthy Carrot Noodles.",
    details: "Rich in Vitamin A. Kids favorite.",
    rating: 4.6,
    inStock: true,
  },
  {
    id: 56,
    name: "Moringa Noodles",
    category: "tiffin",
    image: "/assets/Tiffin/Moringa_Noodles.Main.jpeg",
    images: [
      "/assets/Tiffin/Moringa_Noodles.Main.jpeg",
      "/assets/Tiffin/Moringa_Noodles.Back.jpeg",
    ],
    price: 175,
    offerPrice: 175,
    variants: [{ size: "250g", price: 175, offerPrice: 175 }],
    description: "Healthy Moringa Noodles.",
    details: "Superfood noodles. Nutrient-dense.",
    rating: 4.6,
    inStock: true,
  },
  {
    id: 57,
    name: "Multi Millet Noodles",
    category: "tiffin",
    image: "/assets/Tiffin/Multi_Millet_Noodles.Main.jpeg",
    images: [
      "/assets/Tiffin/Multi_Millet_Noodles.Main.jpeg",
      "/assets/Tiffin/Multi_Millet_Noodles.Back.jpeg",
    ],
    price: 175,
    offerPrice: 175,
    variants: [{ size: "180g", price: 175, offerPrice: 175 }],
    description: "Healthy Multi Millet Noodles.",
    details: "Multiple millets. Complete nutrition.",
    rating: 4.6,
    inStock: true,
  },

  {
    id: 58,
    name: "Spinach Noodles",
    category: "tiffin",
    image: "/assets/Tiffin/Spinach_Noodles.Main.jpeg",
    images: [
      "/assets/Tiffin/Spinach_Noodles.Main.jpeg",
      "/assets/Tiffin/Spinach_Noodles.Back.jpeg",
    ],
    price: 175,
    offerPrice: 175,
    variants: [{ size: "250g", price: 175, offerPrice: 175 }],
    description: "Healthy Spinach Noodles.",
    details: "Rich in iron. Healthy and tasty.",
    rating: 4.6,
    inStock: true,
  },
  {
    id: 59,
    name: "Beetroot Pasta",
    category: "tiffin",
    image: "/assets/Tiffin/Beetroot_Pasta.Main.jpeg",
    images: [
      "/assets/Tiffin/Beetroot_Pasta.Main.jpeg",
      "/assets/Tiffin/Beetroot_Pasta.Back.jpeg",
    ],
    price: 175,
    offerPrice: 175,
    variants: [{ size: "250g", price: 175, offerPrice: 175 }],
    description: "Healthy Beetroot Pasta.",
    details: "Rich in iron. Natural color.",
    rating: 4.6,
    inStock: true,
  },
  {
    id: 60,
    name: "Carrot Pasta",
    category: "tiffin",
    image: "/assets/Tiffin/Carrot_Pasta.Main.jpeg",
    images: [
      "/assets/Tiffin/Carrot_Pasta.Main.jpeg",
      "/assets/Tiffin/Carrot_Pasta.Back.jpeg",
    ],
    price: 175,
    offerPrice: 175,
    variants: [{ size: "250g", price: 175, offerPrice: 175 }],
    description: "Healthy Carrot Pasta.",
    details: "Rich in Vitamin A. Kids favorite.",
    rating: 4.6,
    inStock: true,
  },

  {
    id: 61,
    name: "Moringa Pasta",
    category: "tiffin",
    image: "/assets/Tiffin/Moringa_Pasta.Main.jpeg",
    images: [
      "/assets/Tiffin/Moringa_Pasta.Main.Main.jpeg",
      "/assets/Tiffin/Moringa_Pasta.Main.Back.jpeg",
    ],
    price: 175,
    offerPrice: 175,
    variants: [{ size: "250g", price: 175, offerPrice: 175 }],
    description: "Healthy Moringa Pasta.",
    details: "Superfood pasta. Nutrient-dense.",
    rating: 4.6,
    inStock: true,
  },
  {
    id: 62,
    name: "Multi Millet Pasta",
    category: "tiffin",
    image: "/assets/Tiffin/Multi_Millet_Pasta.Main.jpeg",
    images: [
      "/assets/Tiffin/Multi_Millet_Pasta.Main.jpeg",
      "/assets/Tiffin/Multi_Millet_Pasta.Back.jpeg",
    ],
    price: 175,
    offerPrice: 175,
    variants: [{ size: "180g", price: 175, offerPrice: 175 }],
    description: "Healthy Multi Millet Pasta.",
    details: "Multiple millets. Complete nutrition.",
    rating: 4.6,
    inStock: true,
  },
  {
    id: 63,
    name: "Spinach Pasta",
    category: "tiffin",
    image: "/assets/Tiffin/Spinach_Pasta.Main.jpeg",
    images: [
      "/assets/Tiffin/Spinach_Pasta.Main.jpeg",
      "/assets/Tiffin/Spinach_Pasta.Back.jpeg",
    ],
    price: 175,
    offerPrice: 175,
    variants: [{ size: "250g", price: 175, offerPrice: 175 }],
    description: "Healthy Spinach Pasta.",
    details: "Rich in iron. Healthy and tasty.",
    rating: 4.6,
    inStock: true,
  },
];
